import { twJoin } from "tailwind-merge";

export const ShowWithTransition = ({
  when,
  children,
}: {
  when: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={twJoin(
        "starting-opacity-0 transition-[opacity,display] transition-discrete",
        when ? "opacity-100" : "pointer-events-none hidden opacity-0"
      )}
    >
      {children}
    </div>
  );
};
